<div class="position-relative">
  <input
    class="input-base trailing-icon-padding"
    [class]="{
      'input-large': inputSize() === InputSize.large,
      'input-small': inputSize() === InputSize.small,
    }"
    [type]="showPassword() ? 'text' : 'password'"
    [class.input-error]="error()"
    [attr.id]="controlId()"
    [value]="value()"
    [disabled]="disabled()"
    [autocomplete]="autocomplete()"
    [placeholder]="placeholder()"
    [attr.inputMode]="inputMode()"
    (input)="handleInput($event)" />
  <mat-icon
    class="input-trailing-icon"
    (click)="toggleVisibilityClicked()"
    [class]="{
      'input-trailing-icon-large': inputSize() === InputSize.large,
      'input-trailing-icon-small': inputSize() === InputSize.small,
    }"
    [svgIcon]="showPassword() ? 'visibility' : 'visibility-off'">
  </mat-icon>
</div>
